import { StyleSheet } from 'react-native';

import cardShadow from '../../../../Common/Styles/cardShadow';

export default StyleSheet.create({
  cardContainerStyle: theme => ({
    paddingVertical: 16,
    paddingHorizontal: 16,
    marginHorizontal: 2,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    marginTop: -7,
    ...cardShadow,
  }),
});
